var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw:w-full"},[_c(_setup.BaseMultiselect,{attrs:{"label":"Provincia","name":"provincias","value":_setup.selectedId,"options":_setup.provincias,"label-key":"nombre","value-key":"id","disabled":_vm.disabled,"rules":"required"},on:{"input":_setup.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }